export default () => {
  const counters = document.querySelectorAll('.js-counter')
  if (counters.length < 1) return

  // If the browser does NOT support IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    counters.forEach(counter => countUp(counter))
    return
  }

  // Observer
  let counterObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let counter = entry.target
        countUp(counter)
        counterObserver.unobserve(counter)
      }
    })
  })

  counters.forEach(counter => {
    counterObserver.observe(counter)
  })
}

function countUp(counter) {
  let count = 0
  let nr = counter.dataset.nr ? counter.dataset.nr : 1
  let iteration = 2000 / nr

  let interval = window.setInterval(() => {
    count++
    counter.innerHTML = count
    if (count + 1 === nr || count + 1 > nr) {
      window.clearInterval(interval)
    }
  }, iteration)
}



// WEBPACK FOOTER //
// ./src/js/modules/Counter.js